import { MenuItemOption } from '@chakra-ui/react';
import styled from 'styled-components';
import StatusTag from '@/components/StatusTag';

type InputStyleType = {
  isLabelAboveField?: boolean;
  isActived?: boolean;
};

export const InputBox = styled.div<InputStyleType>`
  display: ${(props) => (props.isLabelAboveField ? 'block' : 'flex')};
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  gap: ${({ isLabelAboveField = false }) => (isLabelAboveField ? 0 : 12)}px;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }

  .chakra-menu__menu-button span div p {
    font-size: 14px;
  }

  * {
    font-size: 12px;
    text-align: left;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    text-align: left;
  }
`;

export const InputLabel = styled.label<InputStyleType>`
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  font-size: 14px;
  flex: 1;
  display: block;
  line-height: 21px;
  min-height: 21px;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const InputArea = styled.div<InputStyleType>`
  flex-shrink: 0;
  position: relative;
  width: ${({ isLabelAboveField = false }) => (isLabelAboveField ? '100%' : '50%')};

  button span {
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    color: ${(props) => props.theme.colors['neutral-100']};
  }

  .chakra-menu__icon-wrapper {
    display: none;
  }
  button {
    &:hover,
    &:focus,
    &[aria-checked='true'],
    &:active,
    &[data-active] {
      background-color: ${({ theme }) => theme.colors['neutral-40']};
    }

    > span {
      font-size: 14px;
      line-height: 21px;
    }
  }
  div {
    min-width: 100% !important;
    width: 100%;
    padding: 0;
  }
  div {
    ::-webkit-scrollbar {
      width: 0px;
    }
    ::-webkit-scrollbar-thumb {
      background: #888;
    }
  }
`;

export const MenuOption = styled(MenuItemOption)`
  &:hover {
    background-color: ${({ theme }) => theme.colors['neutral-30']};
  }
`;

export const MenuTag = styled(StatusTag)`
  & span {
    font-size: 14px;
    line-height: 21px;
    top: 0 !important;
    font-weight: 600;
  }
`;
